import React, { useEffect, useState } from "react";
import {
  Avatar,
  makeStyles,
  ListItem,
  List,
  ListItemIcon,
  ListItemText,
  Box,
} from "@material-ui/core";
import { useParams } from "react-router-dom";
// import Avatar from '@material-ui/core/Avatar';
import DataService from "../../../../../Service";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { createMuiTheme } from "@material-ui/core/styles";
import HeaderMenu from "../../../../../Components/HeaderMenu";
import { useHistory, useLocation } from "react-router";
import { AddCircleOutlined } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { useDispatch } from "react-redux";
import Collapse from "@material-ui/core/Collapse";
import { ReactComponent as OthersIcon } from "./OthersIcon.svg";
import programImage from "../../../../../../src/Images/program1.png";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import CoachRateCard from "../CoachRateCard";
import CoachingRequestForm from "../CoachingRequestForm";
import CompetencySetUp from "../CompetencySetUp";
import Coaches from "../Coaches";
import Program from "../Program";
import Assignment from "../Assignment";
import TermCondition from "../TermCondition";
import CoachingAssignmentForm from "../CoachingAssignementForm";
import EvaluationForm from "../EvaluationForm";
import { DELETE_STEPPER_DATA } from "../../../../../Redux/actions.tsx";
import { useSelector } from "react-redux";

// Reset organisation stepper data
import { ResetOrganisationDetails } from "../../Organisation/Create/OrganisationDetails/OrganisationDetailsActions";
import { ResetActivity } from "../../Organisation/Create/Activity/OrganisationActivityActions";
import { ResetContact } from "../../Organisation/Create/Contact/OrganisationContactActions";
import { ResetContract } from "../../Organisation/Create/Contract/OrganisationContractActions";
import { ResetGeneral } from "../../Organisation/Create/General/OrganisationGeneralActions";
import { ResetBusinessDevelopment } from "../../Organisation/Create/OrganisationBusinessDevelopment/OrganisationBusinessDevelopmentActions";
import { ResetPreContract } from "../../Organisation/Create/PreContract/OrganisationPreContractActions";
import { ResetProfile } from "../../Organisation/Create/Profile/OrganisationProfileActions";

// Reset employee stepper data
import { ResetContactArea } from "../Create/ContactArea/ContactAreaActions";
import { ResetWorkInformation } from "../Create/WorkInformation/WorkInformationActions";
import { ResetTrainingAndDevelopment } from "../Create/TrainingAndDevelopment/TrainingAndDevelopmentActions";
import { ResetCoachingCapacity } from "../Create/CoachingCapacity/CoachingCapatityActions";
import { ResetMentoringCapacity } from "../Create/MentoringCapacity/MentoringCapatityActions";
import { ResetCoachingProfile } from "../Create/CoachingProfile/CoachingProfileActions";
import { ResetMentorProfile } from "../Create/MentorProfile/MentorProfileActions";
import { ResetFacilitation } from "../Create/Facilitation/FacilitationActions";
import { ResetAccessment } from "../Create/Accessment/AccessmentActions";
import { ResetGdpr } from "../Create/Gdpr/GdprActions";
import EmployeeList from "../index";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import formImage from "../../../../../../src/Images/formImage1.png";
import coachesImage from "../../../../../../src/Images/CoachesImage1.png";

export default function EmployeeView() {
  const history = useHistory();

  const dispatch = useDispatch();
  const location = useLocation();
  console.log("location", location.state);

  const disablePage = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail?.others?.terms_and_policy?.disablePage;
  const disableForm = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail?.forms?.disableForm;

  const useStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: "15px",
      backgroundColor: "#F7F7F7",
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    selected: {
      borderLeft: "6px solid #4089FC",
    },
    sidebar: {
      maxHeight: "100%",
      position: "fixed",
      overflowY: "auto",
      left: "0",
      bottom: "0",
      top: "64px",
      width: "25%",
      backgroundColor: "rgba(247, 247, 247)",
    },
    secondaryColorText: {
      color: "#EF7000",
    },
  }));
  const [apiData, setApiData] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [coachFlag, setCoachFlag] = useState(false);
  const [competencyFlag, setCompetencyFlag] = useState(false);
  const [tnCFlag, setTnCFlag] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [programFlag, setProgramFlag] = useState(false);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };
  let { id } = useParams();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [openForm, setOpenForm] = useState(false);

  const handleClick = () => {
    setOpen(!open);
    setChecked(false);
  };
  const handleClickForm = () => {
    setOpenForm(!openForm);
    setCoachRequest(false);
  };

  useEffect(() => {
    switch (location?.state?.index) {
      case 0:
        handleEmployeePanel(true);
        break;
      case 3:
        openCoachPanel();
        break;
      default:
        handleProgramPanel(true);
    }
    if (location?.state?.index !== undefined) {
      console.log("location.state.index", location.state.index);
      setSelectedIndex(location.state.index);
    } else {
      setSelectedIndex(1);
    }
  }, []);

  useEffect(() => {
    dispatch(ResetContactArea());
    dispatch(ResetWorkInformation());
    dispatch(ResetTrainingAndDevelopment());
    dispatch(ResetCoachingCapacity());
    dispatch(ResetMentoringCapacity());
    dispatch(ResetCoachingProfile());
    dispatch(ResetMentorProfile());
    dispatch(ResetFacilitation());
    dispatch(ResetAccessment());
    dispatch(ResetGdpr());
    setLoading(true);
  }, []);

  useEffect(() => {
    getData();
  }, [id]);

  const getData = () => {
    setLoading(true);
    DataService.getData({ id }, "employee")
      .then((response) => {
        let listData = response.data;
        let imageUrl = listData.picture;
        setApiData(listData);
        setImageUrl(imageUrl);
        setLoading(false);
      })
      .catch((err) => {});
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const columns = [
    {
      name: "organisation_name",
      label: "Name",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "Actions",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button
              disableElevation
              variant="outlined"
              color="#F1ECED"
              size="small"
              style={{ textTransform: "none" }}
              onClick={() => {
                history.push("/admin/organisation/create");
              }}
            >
              View
            </Button>
          );
        },
      },
    },
  ];
  const [checked, setChecked] = React.useState(false);
  const [coachRequest, setCoachRequest] = React.useState(false);
  const [coachAssignment, setCoachAssignment] = React.useState(false);
  const [evaluationForm, setEvaluationForm] = React.useState(false);
  const [assignmentFlag, setAssignmentFlag] = React.useState(false);
  const [employeeFlag, setEmployeeFlag] = React.useState(false);

  const openCoachPanel = (params) => {
    setCoachFlag(true);
    setEvaluationForm(false);
    setCoachRequest(false);
    setChecked(false);
    setTnCFlag(false);
    setProgramFlag(false);
    setCompetencyFlag(false);
    setCoachAssignment(false);
    setAssignmentFlag(false);
    setEmployeeFlag(false);
  };
  const handleToggle = (params) => {
    setChecked(true);
    setEvaluationForm(false);
    setCoachRequest(false);
    setCoachFlag(false);
    setTnCFlag(false);
    setProgramFlag(false);
    setCoachAssignment(false);
    setAssignmentFlag(false);
    setEmployeeFlag(false);
  };

  const handleTerms = () => {
    setTnCFlag(true);
    setEvaluationForm(false);
    setCoachRequest(false);
    setCoachFlag(false);
    setChecked(false);
    setProgramFlag(false);
    setCompetencyFlag(false);
    setCoachAssignment(false);
    setAssignmentFlag(false);
    setEmployeeFlag(false);
  };
  const handleCompetencyFlag = () => {
    setCompetencyFlag(true);
    setEvaluationForm(false);
    setCoachRequest(false);
    setCoachFlag(false);
    setChecked(false);
    setTnCFlag(false);
    setProgramFlag(false);
    setCoachAssignment(false);
    setAssignmentFlag(false);
    setEmployeeFlag(false);
  };
  const handleCoachRequest = (params) => {
    setCoachRequest(true);
    setEvaluationForm(false);
    setCompetencyFlag(false);
    setChecked(false);
    setCoachFlag(false);
    setTnCFlag(false);
    setProgramFlag(false);
    setCoachAssignment(false);
    setAssignmentFlag(false);
    setEmployeeFlag(false);
  };
  const handleCoachAssignment = (params) => {
    setCoachAssignment(true);
    setEvaluationForm(false);
    setCoachRequest(false);
    setCompetencyFlag(false);
    setChecked(false);
    setCoachFlag(false);
    setTnCFlag(false);
    setProgramFlag(false);
    setAssignmentFlag(false);
    setEmployeeFlag(false);
  };
  const handleEvaluationForm = (params) => {
    setEvaluationForm(true);
    setCoachAssignment(false);
    setCoachRequest(false);
    setCompetencyFlag(false);
    setChecked(false);
    setCoachFlag(false);
    setTnCFlag(false);
    setProgramFlag(false);
    setAssignmentFlag(false);
    setEmployeeFlag(false);
  };
  const handleProgramPanel = (boolValue) => {
    setEmployeeFlag(boolValue);
    setProgramFlag(boolValue);
    setEvaluationForm(false);
    setCompetencyFlag(false);
    setCoachRequest(false);
    setChecked(false);
    setCoachFlag(false);
    setTnCFlag(false);
    setCoachAssignment(false);
    setAssignmentFlag(false);
    setEmployeeFlag(false);
  };

  //ee//
  const handleAssignmentPanel = (boolValue) => {
    setAssignmentFlag(boolValue);
    setProgramFlag(false);
    setEvaluationForm(false);
    setCompetencyFlag(false);
    setCoachRequest(false);
    setChecked(false);
    setCoachFlag(false);
    setTnCFlag(false);
    setCoachAssignment(false);
    setEmployeeFlag(false);
  };

  //e//
  const handleEmployeePanel = (boolValue) => {
    setEmployeeFlag(boolValue);
    setAssignmentFlag(false);
    setProgramFlag(false);
    setEvaluationForm(false);
    setCompetencyFlag(false);
    setCoachRequest(false);
    setChecked(false);
    setCoachFlag(false);
    setTnCFlag(false);
    setCoachAssignment(false);
  };

  const options = {
    filter: false,
    viewColumns: false,
    selectableRows: false,
    downloadOptions: {
      useDisplayedColumnsOnly: true,
      useDisplayedRowsOnly: true,
      filename: "organisation_list.csv",
    },
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 30, 40, 50],
    responsive: "scroll",
  };
  console.log("apiData", apiData);
  return (
    <React.Fragment>
      <HeaderMenu />
      <Grid container direction="row">
        <Grid
          item
          xs={3}
          style={{
            backgroundColor: "rgb(247, 247, 247)",
          }}
        >
          <Box className={classes.sidebar}>
            <div style={{ backgroundColor: "#EEEEEE" }}>
              <Grid container style={{ paddingTop: "8px" }}>
                <Grid
                  item
                  xs={1}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                    paddingTop: "12px",
                  }}
                >
                  <Box textAlign="left">
                    <ArrowBackIosIcon
                      style={{ fontSize: 16, marginTop: 9 }}
                      color="secondary"
                      onClick={() => {
                        history.goBack();
                      }}
                    />
                  </Box>
                </Grid>
                <Grid
                  container
                  xs={11}
                  style={{ paddingTop: "8px", color: "secondary" }}
                >
                  <Grid item xs={3} style={{ paddingLeft: "32px" }}>
                    <ListItemIcon>
                      <Avatar alt="Remy Sharp" src={apiData.picture} />
                    </ListItemIcon>
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      variant="h2"
                      className={classes.secondaryColorText}
                    >
                      {apiData.organisation_name}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      variant="h2"
                      style={{ padding: "8px 8px 0 32px" }}
                      className={classes.secondaryColorText}
                    >
                      ID: {apiData.org_id}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    style={{
                      maxWidth: "90%",
                      margin: "0 auto",
                      backgroundColor: "#EEEEEE",
                      marginLeft: "32px",
                    }}
                    direction="row"
                  >
                    <Grid
                      item
                      xs={3}
                      style={{
                        flexBasis: "18%",
                      }}
                    >
                      <Typography
                        variant="h2"
                        style={{ paddingTop: "10px" }}
                        // className={classes.secondaryColorText}
                      >
                        Admin
                      </Typography>
                      <Typography
                        variant="h2"
                        style={{ paddingTop: "10px" }}
                        // className={classes.secondaryColorText}
                      >
                        Contact
                      </Typography>
                      <Typography
                        variant="h2"
                        style={{ paddingTop: "10px" }}
                        // className={classes.secondaryColorText}
                      >
                        E-mail{" "}
                      </Typography>
                      <Typography
                        variant="h2"
                        style={{ paddingTop: "10px" }}
                        // className={classes.secondaryColorText}
                      >
                        Address{" "}
                      </Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography variant="h2" style={{ paddingTop: "10px" }}>
                        :
                      </Typography>
                      <Typography variant="h2" style={{ paddingTop: "10px" }}>
                        :
                      </Typography>
                      <Typography variant="h2" style={{ paddingTop: "10px" }}>
                        :
                      </Typography>
                      <Typography variant="h2" style={{ paddingTop: "10px" }}>
                        :
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      style={{
                        maxWidth: "100%",
                        flexBasis: "50%",
                      }}
                    >
                      <Typography
                        variant="h2"
                        style={{ paddingTop: "10px" }}
                        className={classes.secondaryColorText}
                      >
                        {apiData.admin || "N/A"}
                      </Typography>
                      <Typography
                        variant="h2"
                        style={{ paddingTop: "10px" }}
                        className={classes.secondaryColorText}
                      >
                        {" "}
                        +{apiData.contact || "N/A"}
                      </Typography>
                      <Typography
                        variant="h2"
                        style={{ paddingTop: "10px" }}
                        className={classes.secondaryColorText}
                      >
                        {apiData.email || "N/A"}
                      </Typography>
                      <Typography
                        variant="h2"
                        style={{ paddingTop: "10px", paddingBottom: "10px" }}
                        className={classes.secondaryColorText}
                      >
                        {/* {apiData.address_line1}, {apiData.address_line2}{" "}
                        {apiData.city}, {apiData.country} */}
                        {apiData.address}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    style={{ justifyContent: "end", marginTop: "8px" }}
                  >
                    <Grid item xs={9}>
                      <Button
                        disableElevation
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          dispatch(ResetOrganisationDetails());
                          dispatch(ResetActivity());
                          dispatch(ResetBusinessDevelopment());
                          dispatch(ResetContact());
                          dispatch(ResetContract());
                          dispatch(ResetGeneral());
                          dispatch(ResetPreContract());
                          dispatch(ResetProfile());
                          dispatch({ type: DELETE_STEPPER_DATA });

                          history.push({
                            pathname: `/admin/organisation/${id}/edit`,
                            state: {
                              orgName:
                                location?.state?.orgName ??
                                apiData.organisation_name,
                            },
                          });
                        }}
                        style={{
                          color: "white",
                          textTransform: "none",
                          marginBottom: "20px",
                          width: "70px",
                          height: "24px",
                        }}
                      >
                        <EditIcon style={{ marginRight: 10, fontSize: 15 }} />
                        Edit
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
            <Divider />
            <Divider />
            <List
              classes={{
                root: classes.root,
              }}
              component="nav"
              aria-label="main mailbox folders"
            >
              <ListItem
                selected={selectedIndex === 0}
                onClick={(event) => {
                  handleListItemClick(event, 0);
                  handleEmployeePanel(true);
                }}
                button
                classes={{ selected: classes.selected }}
              >
                <ListItemIcon>
                  <img
                    style={{ height: "15px", fill: "red" }}
                    src={programImage}
                    alt="program-img"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="h2">Employee</Typography>}
                />
              </ListItem>
              {/* {!disableAddButton && <Button
                disableElevation
                variant="contained"
                color="secondary"
                onClick={() => {
                  history.push({
                    pathname: `/admin/organisation/${id}/employee/create`,
                    state: {
                      orgName:
                        location?.state?.orgName ?? apiData.organisation_name,
                    },
                  });
                }}
                style={{
                  textTransform: "none",
                  width: "87px",
                  height: "34px",
                  marginLeft: "35%",
                  position: "absolute",
                  left: "110px",
                  top: "15px",
                }}
              >
                <AddCircleOutlined style={{ marginRight: 10, fontSize: 15 }} />
                Create
              </Button>} */}
            </List>
            <Divider />
            <List
              classes={{
                root: classes.root,
              }}
              component="nav"
              aria-label="main mailbox folders"
            >
              <ListItem
                selected={selectedIndex === 1}
                onClick={(event) => {
                  handleListItemClick(event, 1);
                  handleProgramPanel(true);
                }}
                button
                classes={{ selected: classes.selected }}
              >
                <ListItemIcon>
                  <img
                    style={{ height: "15px" }}
                    src={programImage}
                    alt="program-img"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="h2">Program</Typography>}
                />
              </ListItem>
            </List>
            <Divider />
            {/* //eeee/// */}
            <List
              classes={{
                root: classes.root,
              }}
              component="nav"
              aria-label="main mailbox folders"
            >
              <ListItem
                selected={selectedIndex === 2}
                onClick={(event) => {
                  handleListItemClick(event, 2);
                  handleAssignmentPanel(true);
                }}
                button
                classes={{ selected: classes.selected }}
              >
                <ListItemIcon>
                  <img
                    style={{ height: "15px" }}
                    src={programImage}
                    alt="assignment-img"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="h2">Assignments</Typography>}
                />
              </ListItem>
            </List>
            <Divider />
            {/* //eeee/// */}
            <List
              classes={{
                root: classes.root,
              }}
              // style={{height: "750px",}}
              component="nav"
              aria-label="main mailbox folders"
            >
              <ListItem
                selected={selectedIndex === 3}
                onClick={(event) => {
                  handleListItemClick(event, 3);
                  openCoachPanel();
                }}
                button
                classes={{ selected: classes.selected }}
              >
                <ListItemIcon>
                  <img
                    style={{ height: "15px", color: "red" }}
                    src={coachesImage}
                    alt="coaches-img"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h2">
                      Internal Coaches and Mentors
                    </Typography>
                  }
                />
              </ListItem>
            </List>
            <Divider />

            <List
              classes={{
                root: classes.root,
              }}
              component="nav"
              aria-label="main mailbox folders"
            >
              <ListItem
                onClick={(event) => {
                  handleClick();
                }}
                button
                classes={{ selected: classes.selected }}
              >
                <ListItemIcon>
                  <OthersIcon />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="h2">Others</Typography>}
                />
                {open ? <RemoveIcon /> : <AddIcon />}
              </ListItem>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem
                    selected={selectedIndex === 4}
                    onClick={(event) => {
                      handleListItemClick(event, 4);
                      handleToggle();
                    }}
                    button
                    classes={{ selected: classes.selected }}
                    className={classes.nested}
                  >
                    <ListItemText
                      primary={
                        <Typography variant="h2">Coaching Rate Card</Typography>
                      }
                    />
                  </ListItem>
                  {!disablePage && (
                    <ListItem
                      selected={selectedIndex === 5}
                      onClick={(event) => {
                        handleListItemClick(event, 5);
                        handleTerms();
                      }}
                      button
                      classes={{ selected: classes.selected }}
                      className={classes.nested}
                    >
                      <ListItemText
                        primary={
                          <Typography variant="h2">
                            Terms and Policies
                          </Typography>
                        }
                      />
                    </ListItem>
                  )}
                  <ListItem
                    selected={selectedIndex === 6}
                    onClick={(event) => {
                      handleListItemClick(event, 6);
                      handleCompetencyFlag();
                    }}
                    button
                    classes={{ selected: classes.selected }}
                    className={classes.nested}
                  >
                    <ListItemText
                      primary={
                        <Typography variant="h2">Competencies</Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Collapse>
            </List>
            <Divider />
            {!disableForm && (
              <List
                classes={{
                  root: classes.root,
                }}
                component="nav"
                aria-label="main mailbox folders"
              >
                <ListItem
                  button
                  classes={{ selected: classes.selected }}
                  onClick={handleClickForm}
                >
                  <ListItemIcon>
                    <img
                      style={{ height: "16px" }}
                      src={formImage}
                      alt="form-img"
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography variant="h2">Form</Typography>}
                  />
                  {openForm ? <RemoveIcon /> : <AddIcon />}
                </ListItem>
                <Collapse in={openForm} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      selected={selectedIndex === 7}
                      onClick={(event) => {
                        handleListItemClick(event, 7);
                        handleCoachRequest();
                      }}
                      button
                      classes={{ selected: classes.selected }}
                      className={classes.nested}
                    >
                      <ListItemText
                        primary={
                          <Typography variant="h2">
                            Coaching request form
                          </Typography>
                        }
                      />
                    </ListItem>
                    <ListItem
                      selected={selectedIndex === 8}
                      onClick={(event) => {
                        handleListItemClick(event, 8);
                        handleCoachAssignment();
                      }}
                      button
                      classes={{ selected: classes.selected }}
                      className={classes.nested}
                    >
                      <ListItemText
                        primary={
                          <Typography variant="h2">
                            Coaching agreement form
                          </Typography>
                        }
                      />
                    </ListItem>
                    <ListItem
                      selected={selectedIndex === 9}
                      onClick={(event) => {
                        handleListItemClick(event, 9);
                        handleEvaluationForm();
                      }}
                      button
                      classes={{ selected: classes.selected }}
                      className={classes.nested}
                    >
                      <ListItemText
                        primary={
                          <Typography variant="h2">Evaluation form</Typography>
                        }
                      />
                    </ListItem>
                  </List>
                </Collapse>
              </List>
            )}
            <Divider />
          </Box>
        </Grid>
        <Grid item xs={9}>
          {employeeFlag && <EmployeeList organisation={id} />}
          {checked && <CoachRateCard organisationId={id} />}
          {evaluationForm && <EvaluationForm organisationId={id} />}
          {coachRequest && <CoachingRequestForm organisationId={id} />}
          {coachAssignment && <CoachingAssignmentForm organisationId={id} />}
          {coachFlag && (
            <Coaches
              organisationId={id}
              organisationName={location.state?.orgName}
            />
          )}
          {programFlag && (
            <Program
              programFlag={programFlag}
              setProgramFlag={setProgramFlag}
              organisationId={id}
            />
          )}
          {assignmentFlag && <Assignment organisationId={id} />}
          {competencyFlag && <CompetencySetUp organisationId={id} />}
          {tnCFlag && <TermCondition organisationId={id} />}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
